import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BookHeart } from "lucide-react";
import { api } from "@/lib/api";
import { STORY_MODAL } from "@/constants/testIds";

export const StoryModal = ({ open, onOpenChange, onSubmitted }) => {
  const [ownerName, setOwnerName] = useState("");
  const [petName, setPetName] = useState("");
  const [mobile, setMobile] = useState("");
  const [story, setStory] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!ownerName.trim() || mobile.trim().length < 8) {
      toast.error("Name and mobile number are necessary to submit your story.");
      return;
    }
    if (!story.trim()) {
      toast.error("Please write your dog's story.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/stories", { owner_name: ownerName, mobile, pet_name: petName, story });
      toast.success("Thank you for sharing your dog's story!");
      setOwnerName("");
      setPetName("");
      setMobile("");
      setStory("");
      onOpenChange(false);
      onSubmitted?.();
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={STORY_MODAL.dialog} className="max-w-md rounded-[2rem]">
        <DialogHeader>
          <BookHeart className="w-8 h-8 text-[#D97736] mb-2" />
          <DialogTitle className="font-display text-2xl font-bold text-[#0F2520]">
            Write Your Dog's Story
          </DialogTitle>
          <DialogDescription className="font-light text-[#0F2520]/70">
            Name &amp; mobile number are necessary to submit your story.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <Input
            data-testid={STORY_MODAL.ownerNameInput}
            placeholder="Your Name"
            value={ownerName}
            onChange={(e) => setOwnerName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Input
            data-testid={STORY_MODAL.mobileInput}
            placeholder="Mobile Number"
            type="tel"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Input
            data-testid={STORY_MODAL.petNameInput}
            placeholder="Your Dog's Name (optional)"
            value={petName}
            onChange={(e) => setPetName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Textarea
            data-testid={STORY_MODAL.storyInput}
            placeholder="Tell us your dog's story..."
            value={story}
            onChange={(e) => setStory(e.target.value)}
            className="rounded-xl min-h-[120px]"
          />
          <Button
            data-testid={STORY_MODAL.submitBtn}
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#0F2520] hover:bg-[#D97736] text-white font-semibold"
          >
            {loading ? "Submitting..." : "Submit Story"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
